// The attachment list under an email box (2026-10-08): each file with its
// size and a remove button, and an image opens in the lightbox showing the
// exact dataUrl Send transmits. Extracted from SuggestionPanel.jsx so the New
// view uses the same one. The list is the caller's state; this only renders it.
import { useCallback, useMemo, useState } from 'react'
import { Stack, Typography, Tooltip, Link, IconButton } from '@mui/material'
import ImageLightbox from './ImageLightbox.jsx'
import { isPreviewableAttachment, previewImagesFor, formatAttachmentSize } from './attachmentPreview.js'

export default function EmailAttachmentList({ attachments, onRemove, disabled = false }) {
  const previewImages = useMemo(() => previewImagesFor(attachments), [attachments])
  const [previewIndex, setPreviewIndex] = useState(null)
  const closePreview = useCallback(() => setPreviewIndex(null), [])
  const identityUrl = useCallback((url) => url, [])
  return (
    <>
      {attachments.map((a) => (
        <Stack key={a.id} direction="row" spacing={1} alignItems="center">
          {isPreviewableAttachment(a) ? (
            <Tooltip title="Click to preview">
              <Link component="button" type="button" variant="body2" aria-label={`Preview ${a.name}`}
                onClick={() => setPreviewIndex(previewImages.findIndex((p) => p.id === a.id))}
                sx={{ flex: 1, minWidth: 0, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {a.name}
              </Link>
            </Tooltip>
          ) : (
            <Typography variant="body2" sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {a.name}
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary">{formatAttachmentSize(a.size)}</Typography>
          <IconButton size="small" disabled={disabled} onClick={() => onRemove(a.id)} aria-label={`Remove ${a.name}`}>
            ✕
          </IconButton>
        </Stack>
      ))}
      <ImageLightbox images={previewImages} index={previewIndex} onClose={closePreview}
        onNavigate={setPreviewIndex} fullResUrl={identityUrl} />
    </>
  )
}
